import api from './api';

class Analytics {
  constructor() {
    this.sessionId = this.getOrCreateSessionId();
    this.startTime = Date.now();
    
    // Envoyer la durée de session quand l'utilisateur quitte
    window.addEventListener('beforeunload', () => {
      this.trackSessionEnd();
    });
  }

  getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem('analytics_session_id');
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
  }

  getSource() {
    // Détecter la source du trafic
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    if (utmSource) return utmSource;
    
    const referrer = document.referrer;
    if (referrer.includes('google.com')) return 'google';
    if (referrer.includes('facebook.com')) return 'facebook';
    if (referrer.includes('twitter.com')) return 'twitter';
    if (referrer.includes('linkedin.com')) return 'linkedin';
    if (referrer.includes('instagram.com')) return 'instagram';
    if (referrer.includes('stripe.com')) return 'checkout.stripe.com';
    if (referrer.includes('fluent.fr')) return 'fluent.fr';
    if (referrer.includes('vercel.com')) return 'vercel.com';
    
    return 'Direct';
  }

  async getCountry() {
    // Utiliser l'API gratuite ipapi.co
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      return data.country_code || 'FR';
    } catch {
      return 'FR'; // Fallback
    }
  }

  async trackPageView(page, metadata = {}) {
    const now = new Date();
    const country = await this.getCountry();
    
    const event = {
      type: 'pageview',
      sessionId: this.sessionId,
      page: page,
      source: this.getSource(),
      country: country,
      timestamp: now.toISOString(),
      ...metadata
    };
    
    // Stocker localement (optionnel)
    this.saveEventLocally(event);
    
    // Envoyer au backend (fire and forget)
    try {
      await api.post('/analytics/track', event);
    } catch (error) {
      console.error('Erreur tracking:', error);
    }
  }

  async trackEvent(eventName, metadata = {}) {
    const now = new Date();
    const event = {
      type: eventName,
      sessionId: this.sessionId,
      timestamp: now.toISOString(),
      ...metadata
    };
    
    this.saveEventLocally(event);
    
    try {
      await api.post('/analytics/track', event);
    } catch (error) {
      console.error('Erreur tracking:', error);
    }
  }

  async trackConversion(bookingId, amount) {
    await this.trackEvent('conversion', { bookingId, amount });
  }

  saveEventLocally(event) {
    const events = JSON.parse(localStorage.getItem('analytics_events') || '[]');
    events.push(event);
    // Garder seulement les 100 derniers événements
    if (events.length > 100) events.shift();
    localStorage.setItem('analytics_events', JSON.stringify(events));
  }

  trackSessionEnd() {
    const duration = Math.floor((Date.now() - this.startTime) / 1000);
    if (duration > 5) { // Ignorer les sessions très courtes
      this.trackEvent('session_end', { duration });
    }
  }
}

// Export une instance unique
export const analytics = new Analytics();